import React from 'react';
import PropTypes from 'prop-types';
import { get, values } from 'lodash/fp';
import { Button, Icon } from 'rsuite';
import Link from '../../Link';
import InventoryActions from '../../../constants/inventory/InventoryActions';
import IconByAdjustAction from '../../../constants/inventory/IconByAdjustAction';

const ActionIconLink = ({
  to,
  action,
  label,
  icon,
  size,
  disabled,
  appearance,
  ...props
}) => (
  <Link {...props} to={to}>
    <Button size={size} appearance={appearance} disabled={disabled || false}>
      <Icon icon={icon || get(action, IconByAdjustAction)} />
      {` ${label}`}
    </Button>
  </Link>
);

ActionIconLink.propTypes = {
  to: PropTypes.shape({}).isRequired,
  action: PropTypes.oneOf(values(InventoryActions)),
  label: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
  appearance: PropTypes.string,
  disabled: PropTypes.bool
};

ActionIconLink.defaultProps = {
  action: null,
  label: '',
  size: 'sm',
  icon: '',
  appearance: 'default',
  disabled: false
};

export default ActionIconLink;
